import React, {PropTypes} from 'react';
import {Field} from 'redux-form';
import Submitting from 'shared/Submitting.jsx';
import StandardField from 'shared/StandardField.jsx';
import StandardSelectField from 'shared/StandardSelectField.jsx';
import StandardCheckboxField from 'shared/StandardCheckboxField.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';
import EntryRosterFormVirtualEntriesToModifyContainer from './EntryRosterFormVirtualEntriesToModifyContainer.jsx';

const EntryRosterForm = ({
  disableState,
  roster,
  rosterPositionsQty,
  countries,
  states,
  parentVirtualEntryEvents,
  parentTeamOwnedVirtualEntries,
  entryId,
  eventId,
  handleSubmit,
  pristine,
  submitting,
  rosterCheckout,
  onCancelClick,
  onSubmit,
  onCountryChange,
  onAssignTeamOwnedVirtualEventClick
}) => {
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      noValidate>
      <ErrorListContainer/>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column'
      }}> 
        <div className="row">
          <div className="col-sm-6 col-xs-12">
            <Field
              disabled={rosterPositionsQty === 2 || rosterPositionsQty === 1}
              autoFocus={rosterPositionsQty > 2}
              className="form-control"
              name="name"
              type="text"
              placeholder="Team Name"
              component={StandardField}/>
          </div>      
          <div className="col-sm-6 col-xs-12">
              <Field
                className="form-control"
                name="pairCode"
                type="text"
                placeholder="Companion Code"
                component={StandardField}
                tooltip="(Optional) Enter the Reservation Number of the other team you want to bowl/cross with on your pair."
                tooltipPosition="top"/>
          </div>  
        </div>
        <div className="row">
          <div className="col-sm-6 col-xs-12">
            <Field
              name="countryId"
              placeholder="Country"
              component={StandardSelectField}
              options={countries}
              simpleValue
              searchable
              matchPos="start"
              onCustomChange={onCountryChange}/>
          </div>
          <div className="col-sm-6 col-xs-12">
            <Field
              disabled={disableState}
              className="form-control"
              name="state"
              placeholder="State"
              component={StandardSelectField}
              options={states}
              simpleValue
              searchable
              matchPos="start"/>
          </div>
        </div>
        {parentVirtualEntryEvents.filter(x => x.eventId === eventId).length > 0
          ? parentVirtualEntryEvents.filter(x => x.eventId === eventId).map((virtualEvent, index) => {
            let entry = parentTeamOwnedVirtualEntries.find(entry => (entry.teamEntryId == entryId) &&
              (entry.virtualEventName == virtualEvent.name));
            let entryAssigned = entry ? true : false;
            let remaining = rosterCheckout
              ? parentTeamOwnedVirtualEntries.filter(entry => entry.virtualEventName === virtualEvent.name &&
                !entry.isPurchased &&
                entry.teamEntryId == null).length
              : virtualEvent.remaining;

            return (
              <div className="row"
                   key={index}>
                <div className="col-xs-12">
                  <Field
                    id={`assignVirtualEntry${index}`}
                    name={`assignVirtualEntry${index}`}
                    checked={entryAssigned}
                    disabled={(rosterCheckout && entryAssigned && (entry ? entry.isPurchased : true)) ||
                      (!entryAssigned && remaining === 0)}
                    component={StandardCheckboxField}
                    label={`Assign ${virtualEvent.name} (${rosterCheckout &&
                      entryAssigned &&
                      (entry ? entry.isPurchased : true)
                      ? `already assigned`
                      : `${remaining} remaining`})`}
                    title={rosterCheckout && entryAssigned
                      ? `This virtual event is already assigned to this entry. Its assignment can be changed on the Manage page after checkout.`
                      : null}
                    onCustomChange={(event) => onAssignTeamOwnedVirtualEventClick(virtualEvent.name,
                      entryId,
                      event.target.checked)}/>
                </div>
              </div>
            );
          })
          : null
        }

        {roster}
        <EntryRosterFormVirtualEntriesToModifyContainer/>
        <br/>

        <div className="form-group text-right">
          <button
            type="button"
            className="btn btn-link"
            disabled={submitting}
            onClick={onCancelClick}>Cancel</button>
          {` `}
          <button
            type="submit"
            className="btn btn-primary btn-lg"
            disabled={pristine || submitting}>{submitting ? <Submitting/> : <i className="fa fa-floppy-o"/>} {
              `Save Changes`}</button>
        </div>
      </div>
    </form>
  );
};

EntryRosterForm.propTypes = {
  disableState: PropTypes.bool,
  roster: PropTypes.node,
  rosterPositionsQty: PropTypes.number,
  countries: PropTypes.arrayOf(PropTypes.object),
  states: PropTypes.arrayOf(PropTypes.object),
  parentVirtualEntryEvents: PropTypes.arrayOf(PropTypes.object),
  parentTeamOwnedVirtualEntries: PropTypes.arrayOf(PropTypes.object),
  entryId: PropTypes.string,
  eventId: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool.isRequired,
  onCancelClick: PropTypes.func,
  onSubmit: PropTypes.func,
  onCountryChange: PropTypes.func,
  onAssignTeamOwnedVirtualEventClick: PropTypes.func,
  rosterCheckout: PropTypes.bool
};

EntryRosterForm.defaultProps = {
  disableState: false,
  rosterPositionsQty: 0,
  countries: [],
  states: [],
  submitting: false,
  rosterCheckout: window.location.href.indexOf("rostercheckout") >= 0
};

export default EntryRosterForm;



// WEBPACK FOOTER //
// ./src/features/registration/manage/EntryRosterForm.jsx